module.exports = __webpack_public_path__ + "static/slack-mockup-cc6213f36382f86d3dddecc1eb38862a.png";